const PARTICULARES_KEY = 'app_particulares';
const ACTIVE_PARTICULAR_KEY = 'app_particular_activo';
const ACTIVE_PARTICULAR_ID_KEY = 'app_particular_activo_id';

const getParticularId = (particular) => particular?.id || particular?.Id || null;

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error guardando particular en localStorage:', key, error);
  }
};

const safeGetItem = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    console.error('Error leyendo particular desde localStorage:', key, error);
    return fallback;
  }
};

const ParticularService = {
  setParticulares(particulares = []) {
    safeSetItem(PARTICULARES_KEY, Array.isArray(particulares) ? particulares : []);
  },

  getParticulares() {
    return safeGetItem(PARTICULARES_KEY, []);
  },

  setActiveParticular(particular) {
    safeSetItem(ACTIVE_PARTICULAR_KEY, particular || null);
    safeSetItem(ACTIVE_PARTICULAR_ID_KEY, getParticularId(particular));
  },

  getActiveParticular() {
    return safeGetItem(ACTIVE_PARTICULAR_KEY, null);
  },

  getActiveParticularId() {
    return safeGetItem(ACTIVE_PARTICULAR_ID_KEY, null);
  },

  syncActiveParticular(particular) {
    const particularId = getParticularId(particular);
    if (!particularId) return null;

    const particulares = this.getParticulares();
    const activeParticular = this.getActiveParticular();
    const activeParticularId = getParticularId(activeParticular);
    const existing = particulares.find((item) => String(getParticularId(item)) === String(particularId));
    const merged = {
      ...(existing || {}),
      ...(String(activeParticularId || '') === String(particularId) ? activeParticular : {}),
      ...particular
    };
    const updatedParticulares = existing
      ? particulares.map((item) => (
          String(getParticularId(item)) === String(particularId) ? merged : item
        ))
      : [...particulares, merged];

    this.setParticulares(updatedParticulares);
    this.setActiveParticular(merged);
    return merged;
  },

  clearParticularData() {
    try {
      localStorage.removeItem(PARTICULARES_KEY);
      localStorage.removeItem(ACTIVE_PARTICULAR_KEY);
      localStorage.removeItem(ACTIVE_PARTICULAR_ID_KEY);
    } catch (error) {
      console.error('Error limpiando datos de particulares:', error);
    }
  }
};

export default ParticularService;
